import React from "react";

export const OfflineExam = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0" y="0" width="64" height="64" fill="#4D96FF" rx="8" ry="8" />
    <rect x="15" y="15" width="25" height="34" rx="3" ry="3" fill="white" />
    <path d="M20 18h15v4H20z" fill="#D1E3FF" />
    <path d="M20 25h15v2H20zM20 30h15v2H20zM20 35h10v2H20z" fill="#4D96FF" />
    <circle
      cx="38"
      cy="38"
      r="9"
      fill="white"
      stroke="#6BCB77"
      strokeWidth="2"
    />
    <line x1="42" y1="42" x2="48" y2="48" stroke="#6BCB77" strokeWidth="2" />
    <line x1="38" y1="34" x2="38" y2="42" stroke="#6BCB77" strokeWidth="2" />
    <line x1="34" y1="38" x2="42" y2="38" stroke="#6BCB77" strokeWidth="2" />
    <rect x="50" y="20" width="4" height="15" fill="#FFD93D" />
    <rect x="57" y="25" width="4" height="10" fill="#884DFF" />
    <rect x="43" y="18" width="4" height="17" fill="#6BCB77" />
  </svg>
);

export const AIExamEvaluation = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0"
      y="0"
      width="64"
      height="64"
      fill="url(#backgroundGradient)"
      rx="8"
      ry="8"
    />
    <defs>
      <linearGradient id="backgroundGradient" x1="0" y1="0" x2="64" y2="64">
        <stop offset="0%" stopColor="#FFA500" />
        <stop offset="100%" stopColor="#FF4500" />
      </linearGradient>
    </defs>
    <circle cx="32" cy="32" r="20" fill="#FFE4B5" />
    <line x1="20" y1="32" x2="44" y2="32" stroke="#FF8C00" strokeWidth="2" />
    <line x1="32" y1="20" x2="32" y2="44" stroke="#FF8C00" strokeWidth="2" />
    <circle cx="32" cy="32" r="4" fill="#FF4500" />
    <circle cx="20" cy="32" r="3" fill="#FF6347" />
    <circle cx="44" cy="32" r="3" fill="#FFA07A" />
    <circle cx="32" cy="20" r="3" fill="#FFD700" />
    <circle cx="32" cy="44" r="3" fill="#FF7F50" />
    <text x="5" y="10" fontFamily="Arial" fontSize="4" fill="#FF8C00">
      101010
    </text>
    <text x="50" y="60" fontFamily="Arial" fontSize="4" fill="#FF6347">
      010101
    </text>
    <circle cx="10" cy="50" r="4" fill="#FFD700" />
    <line x1="10" y1="46" x2="10" y2="54" stroke="#FF4500" strokeWidth="1.5" />
    <line x1="6" y1="50" x2="14" y2="50" stroke="#FF4500" strokeWidth="1.5" />
  </svg>
);

export const Filter = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="filter-icon"
    width="24"
    height="24"
  >
    <path d="M4 4h16v2l-6 6v6l-4-2v-4L4 6V4z" />
  </svg>
);

export const Download = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width="24"
    height="24"
  >
    <path d="M12 2a1 1 0 011 1v12.586l3.293-3.293a1 1 0 011.414 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L11 15.586V3a1 1 0 011-1z" />
    <path d="M4 20a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1z" />
  </svg>
);
